'use client'
import {
  parseSectionItem
} from "./chunk-DJNQ4XY4.mjs";

// src/hooks/filters/useSectionTagFilter.tsx
import { useMemo, useState } from "react";
import { useRouter } from "@wbk/config";
var useSectionTagFilter = ({ items, tags }) => {
  const [tag, setTag] = useState();
  const { locale } = useRouter();
  const filteredItems = useMemo(() => {
    const parsedItems = items.map((item) => parseSectionItem({ item, locale })).filter((item) => Boolean(item));
    if (!(tags == null ? void 0 : tags.length) || !tag) return parsedItems;
    return parsedItems.filter((item) => {
      var _a;
      const itemTags = (_a = item.cmsTagsCollection) == null ? void 0 : _a.items;
      if (!(itemTags == null ? void 0 : itemTags.length)) return false;
      return itemTags.some((t) => t.id === tag.id);
    });
  }, [items, locale, tags, tag]);
  return {
    tag,
    setTag,
    filteredItems
  };
};

export {
  useSectionTagFilter
};
//# sourceMappingURL=chunk-ISPH2TSR.mjs.map